import { setAlert } from './alert';
import URL from './url';
import { GET_EMPRESAS, GET_EMPRESA, EMPRESAS_ERROR } from './types';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

// Crear una nueva empresa
export const addEmpresa = (formData) => async dispatch => {
  try {
    const res = await URL.post('/api/empresas', formData, config);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }
  }
};

// Obtener todas las empresas
export const getEmpresas = () => async dispatch => {
  try {
    const res = await URL.get('/api/empresas');
    dispatch({
      type: GET_EMPRESAS,
      payload: res.data
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: EMPRESAS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Obtener empresa por ID
export const getEmpresaById = (id) => async dispatch => {
  try {
    const res = await URL.get(`/api/empresas/${id}`);
    dispatch({
      type: GET_EMPRESA,
      payload: res.data
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: EMPRESAS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Editar empresa
export const updateEmpresa = (id, formData) => async dispatch => {
  try {
    const res = await URL.patch(`/api/empresas/${id}`, formData, config);
    dispatch(setAlert('Empresa actualizada correctamente', 'success'));
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    } else {
      dispatch(setAlert('Error al actualizar empresa', 'danger'));
    }
  }
};

// Cambiar estatus de empresa
export const updateEmpresaStatus = (id, status) => async dispatch => {
  try {
    const res = await URL.patch(`/api/empresas/${id}/status`, { status }, config);
    dispatch(setAlert('Estatus actualizado correctamente', 'success'));
    return res.data;
  } catch (err) {
    console.error(err);
    dispatch(setAlert('Error al actualizar estatus', 'danger'));
  }
};

// Eliminar empresa
export const deleteEmpresa = (id) => async dispatch => {
  try {
    await URL.delete(`/api/empresas/${id}`);
    dispatch(setAlert('Empresa eliminada correctamente', 'success'));
    return true;
  } catch (err) {
    console.error(err);
    dispatch(setAlert('Error al eliminar empresa', 'danger'));
    return false;
  }
};
